"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var React = require("react");
var react_1 = require("react");
var FormGroup_1 = require("./FormGroup");
/**
 * Render html input in a FormGroup.
 *
 * Example:
 * ```
 * const form = useForm({ email: null })
 * <Input
 *   label="Email"
 *   field={form.email}
 *   required
 * />
 * ```
 */
var Input = function (_a) {
    var field = _a.field, type = _a.type, label = _a.label, autoFocus = _a.autoFocus, disabled = _a.disabled, right = _a.right, placeholder = _a.placeholder, _b = _a.inputType, inputType = _b === void 0 ? "text" : _b, id = _a.id, className = _a.className, other = __rest(_a, ["field", "type", "label", "autoFocus", "disabled", "right", "placeholder", "inputType", "id", "className"]);
    var ref = react_1.useRef();
    field.setFieldElement({
        constraint: other,
        type: type,
        focus: function () { return ref.current.focus(); },
        blur: function () { return ref.current.blur(); },
    });
    return (React.createElement(FormGroup_1.FormGroup, { label: label, invalidFeedback: field.getError() },
        React.createElement("input", { type: inputType, className: className || "form-control", value: field.getValue(), onChange: function (e) { return field.setValue(e.target.value); }, onBlur: field.onBlur, onFocus: field.onFocus, ref: ref, autoFocus: autoFocus, disabled: disabled, placeholder: placeholder, id: id }),
        right));
};
exports.Input = Input;
